export const HelproomMessagingTopics = {
  getConversationMessageQueue: (helproom_id: string): string => `/helproom/${helproom_id}/conversation`, // used for send messages only
  getStaffersMessageQueue: (helproom_id: string): string => `/helproom/${helproom_id}/staff-conversation`, // used for sending staffer messages only
  getParticipantsUpdateQueue: (helproom_id: string): string => `/helproom/${helproom_id}/participant.update`,
  getVisitorOneOnOneTopic: (helproom_id: string, operator_id: string, visitor_id: string): string => `/helproom/${helproom_id}/one-to-one/${operator_id}/${visitor_id}`, // used for sending one-to-one messages only
  getHelproomSessionTypingTopic: (helproom_id: string): string => `/helproom/${helproom_id}/is-typing`,
  getHelproomStaffTypingQueue: (helproom_id: string): string => `/helproom/${helproom_id}/staff-conversation/is-typing`,
  getVisitorOneOnOneTypingQueue: (helproom_id: string, operator_id: string, visitor_id: string): string => `/helproom/${helproom_id}/one-to-one/${operator_id}/${visitor_id}/is-typing`,
  getVirtualTopicConversationMessageQueue: (operator_id: string, helproom_id: string): string => `/queue/Consumer.${operator_id}.VirtualTopic.helproom.${helproom_id}.conversation`,
  getVirtualTopicOneonOne: (helproom_id: string, operator_id: string, visitor_id: string): string => `/queue/Consumer.${operator_id}.VirtualTopic.helproom.${helproom_id}.one-to-one.${operator_id}.${visitor_id}`,
  getVirtualTopicStaffersMessageQueue: (operator_id: string, helproom_id: string): string => `/queue/Consumer.${operator_id}.VirtualTopic.helproom.${helproom_id}.staff-conversation`,
  getVirtualTopicStafferReviewMessageQueue: (operator_id: string, helproom_id: string): string => `/queue/Consumer.${operator_id}.VirtualTopic.helproom.${helproom_id}.staffer-review-messages`,
};

//False Positive : BUG in ESLINT
// eslint-disable-next-line no-shadow
export enum WebSocketTypes {
  App = '/app',
  Topic = '/topic',
  Queue = '/queue',
}

//False Positive : BUG in ESLINT
// eslint-disable-next-line no-shadow
export enum ActiveHelproomTaskComponentType {
  helproomActiveSession = 'helproom-active-session',
  staffersGroup = 'staffers-group',
  visitorOneOnOne = 'visitor-one-on-one',
}

export const HelproomConstants = {
  MINIMUM_LENGTH: 30,
};
